import Image from 'next/image';
import { useRouter } from 'next/router';
import React from 'react';
import { useSessionStorage } from 'react-use';

import {
  BookingManagementPageLayout,
  ManageBookingRequestFlow,
  useBookingManagementFeatureBlock,
} from '@/booking-management';
import { Box, Grid } from '@/box';
import { useSyncHotelCurrency } from '@/currency-preview/state';
import { SmallPageWrapper } from '@/ui/layout';
import { useTheme } from '@/ui/theme';

interface ManageBookingProps {}

export const ManageBooking: React.FC<ManageBookingProps> = () => {
  useBookingManagementFeatureBlock();
  useSyncHotelCurrency(undefined);

  const { push, query } = useRouter();

  const {
    componentProperties: { bookingManagement: bookingManagementStyles },
  } = useTheme();

  const [, setLoginEmail] = useSessionStorage<string>('login-email');

  // We should only show the form if we're not handling a redirect action
  // const [showForm, setShowForm] = useState(false);

  // if (!showForm) {
  //   return <BookingManagementPageLoadingLayout />;
  // }

  return (
    <BookingManagementPageLayout>
      <Grid
        gridTemplateColumns={[
          '100%',
          '100%',
          String(
            bookingManagementStyles?.pageWrapper?.login?.gridTemplateColumns
          ) ?? '100%',
        ]}
      >
        <SmallPageWrapper
          alignContent={
            bookingManagementStyles?.pageWrapper?.login?.alignContent
          }
          maxWidth={bookingManagementStyles?.pageWrapper?.login?.maxWidth}
        >
          <ManageBookingRequestFlow
            onSuccess={async (email) => {
              setLoginEmail(email);
              await push('./verify');
            }}
            didSessionExpire={Boolean(query.expired)}
          />
        </SmallPageWrapper>
        {bookingManagementStyles?.heroImage ? (
          <Box
            height={'calc(100vh - 60px)'}
            marginTop="-80px"
            marginBottom="-42px"
            display={['none', 'none', 'block']}
          >
            <Image
              src={bookingManagementStyles?.heroImage?.url ?? ''}
              alt={bookingManagementStyles?.heroImage?.alt ?? ''}
              height={1200}
              width={1200}
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          </Box>
        ) : null}
      </Grid>
    </BookingManagementPageLayout>
  );
};

export default ManageBooking;
